import { HttpStatus } from "./http-status";

export class BaseResponseListModel<T> {
    data: Array<T> = [];
    status: HttpStatus = HttpStatus.Failed;
    recordsTotal: number;
    message: string;
}
